import { JSX, useState, useEffect } from 'react';
import { calendarService } from '../../services/calendarService';
import EventView from './eventView';
import { CalendarEvent } from '../../services/calendarService';
import './events.css';
import EventEdit from './eventEdit';
import Loading from '../../common/Loading/loading';

const Events = (): JSX.Element => {
    const [events, setEvents] = useState<CalendarEvent[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    
    const fetchEvents = async () => {
        setIsLoading(true);
        setError(null);
        
        try {
            const events = await calendarService.getEvents(null, null, 'HYTE');
            setEvents(events);
        } catch (err: any) {
            console.error("Failed to load events:", err);
            setError(err.message || "Failed to load events. Please try again.");
            
            // Optional: Handle authentication errors specifically
            if (err.message === 'GOOGLE_AUTH_REQUIRED') {
                setError("Google Calendar authentication required. Please log in again.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, []);

    return (
        <div>
            <EventEdit handleAddEvent={fetchEvents}/>
            <div className='divider-horizontal'/>
            
            {error && (
                <div className="error-message">
                    {error}
                    <button onClick={() => window.location.reload()}>Retry</button>
                </div>
            )}
            
            <div className='events-view-container'>
                {events.length > 0 ? (
                    events.map((event) => (
                        <EventView key={event.id} event={event} displayDate={true} handelEventUpdate={fetchEvents}/>
                    ))
                ) : !isLoading && !error && (
                    <div className="no-events-message">No events found</div>
                )}
            </div>
            
            {isLoading && <Loading/>}
        </div>
    )
}

export default Events;
